import Vue from 'vue'
import Router from 'vue-router'
import ProjectDetail from '../view/ProjectDetail.vue'
Vue.use(Router)

export default new Router({
  mode: 'history', // 改为history模式，去掉hash
  base: '/', // 设置base路径
  routes: [
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '新領海機械行有限公司 - 香港專業工程機械服務供應商',
            description: '新領海機械行是香港領先的工程機械供應商，徐工集團香港一級代理商。提供機械租賃、維修保養、配件銷售，15分鐘響應、1小時到場、24小時服務。覆蓋香港國際機場、啟德新區等大型項目。',
            keywords: '新領海機械行,香港機械公司,徐工集團香港代理,機械租賃,機械維修,履帶式起重機,挖掘機,工程機械'
          }
        },
        {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '服務項目 - 新領海機械行有限公司',
            description: '新領海機械行提供全方位工程機械服務：設備租賃、維修保養、徐工集團授權代理銷售、技術支援。15分鐘快速響應，1小時內專業團隊到達現場，香港及深圳設有倉庫。',
            keywords: '工程機械服務,機械設備租賃,徐工集團授權代理,設備維修保養,技術支援,香港機械公司'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新聞動態 - 新領海機械行有限公司',
            description: '新領海機械行最新公司動態、工程機械行業資訊、徐工集團產品更新。了解香港機械市場趨勢及我們在機場、啟德、填海等項目的服務進展。',
            keywords: '新領海機械行新聞,工程機械行業動態,香港機械公司資訊,徐工集團香港代理'
          }
        }, {
          path: '/newsdetail',
          name: 'newsdetail',
          component: resolve => require(['@/view/NewsDetail'], resolve),
          meta: {
            title: '新聞詳情 - 新領海機械行有限公司',
            description: '新領海機械行新聞詳情，提供公司最新動態、工程機械行業資訊及香港大型項目服務進展。徐工集團香港一級代理商最新消息。',
            keywords: '新聞詳情,新領海機械行,公司動態,工程機械資訊,徐工集團香港代理'
          }
        }, {
          path: '/news/:id',
          name: 'newsdetail-slug',
          component: resolve => require(['@/view/NewsDetail'], resolve),
          meta: {
            title: '新聞詳情 - 新領海機械行有限公司',
            description: '新領海機械行新聞詳情，提供公司最新動態、工程機械行業資訊及香港大型項目服務進展。徐工集團香港一級代理商最新消息。',
            keywords: '新聞詳情,新領海機械行,公司動態,工程機械資訊,徐工集團香港代理'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介紹 - 新領海機械行有限公司',
            description: '新領海機械行成立於2015年，香港知名工程機械公司，徐工集團香港一級代理商。從事機械租賃、維修及配件銷售，設備遍布香港國際機場、啟德新區、填海工程。',
            keywords: '新領海機械行,公司介紹,徐工集團香港代理,工程機械公司,機械租賃,香港機械公司'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作機會 - 新領海機械行有限公司',
            description: '加入新領海機械行工程機械團隊。我們提供具競爭力的薪酬、專業培訓及良好發展空間。招聘機械維修、設備操作等職位，歡迎投遞履歷。',
            keywords: '新領海機械行招聘,工程機械職位,香港機械公司就業,機械維修工程師'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '聯繫我們 - 新領海機械行有限公司',
            description: '聯繫新領海機械行：電話+852-3956-3953，24小時服務。香港新界屯門建發里4號。15分鐘響應，1小時到達現場，機械租賃、維修、配件諮詢。',
            keywords: '新領海機械行聯繫,香港機械公司電話,工程機械服務熱線,機械租賃諮詢'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '服務詳情 - 新領海機械行有限公司',
            description: '新領海機械行專業機械服務詳情：設備租賃、維修保養、徐工集團正品銷售。服務範圍、技術特點、15分鐘響應承諾，95%配件1天內更換。',
            keywords: '機械服務詳情,設備租賃,維修保養,徐工集團香港代理,工程機械服務'
          }
        }
      ]
    },
    {
      path: '/project/detail/:project',
      name: 'ProjectDetail',
      component: ProjectDetail,
      meta: {
        title: '項目詳情 - 新領海機械行有限公司',
        description: '查看新領海機械行成功案例和項目詳情，了解我們的專業服務和技術實力。',
        keywords: '項目案例,成功案例,工程項目,機械應用'
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: resolve => require(['@/view/NotFound'], resolve),
      meta: {
        title: '頁面未找到 - 新領海機械行有限公司',
        description: '您訪問的頁面不存在。',
        keywords: '404, 頁面未找到'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js